import { Button, Card, Col, Row } from '@themesberg/react-bootstrap';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { DateFormatter2 } from '../helpers/DateFormatter2';
import ColorComponent from './ColorComponent';

const Labels = (key, value) => {
  return (
    <Col md={4} className='mb-3'>
      <h6>{key ?? ''}:</h6>
      <h7>{value ?? ''}</h7>
    </Col>
  );
};

const CollectorDetailHeader = ({ collectorData }) => {
  const history = useHistory();
  return (
    <Col md={12} className={'mt-3'}>
      <Card border='light' className='bg-white shadow-sm mb-4 p-0'>
        <Card.Body>
          <Row className='d-flex align-items-center mb-3'>
            <Col md={12} lg={6}>
              <h5>{collectorData?.username}</h5>
            </Col>

            <Col
              md={12}
              lg={6}
              className='d-flex'
              style={{ justifyContent: 'flex-end' }}
            >
              <Button
                variant='primary'
                onClick={() => {
                  history.push(`/collectors/edit/${collectorData.id}`);
                }}
              >
                Edit Collector Details
              </Button>
            </Col>
          </Row>
          <Row>
            {Labels('Collector Id', collectorData?.id)}
            <Col md={4} className='mb-3'>
              <h6>{'Status'}:</h6>
              <ColorComponent value={collectorData.isActive} />
            </Col>

            {Labels('Phone Number', collectorData?.mobileNumber)}
            {Labels('Email', collectorData?.email)}
            {Labels(
              'Total Assigned Customers',
              collectorData?.totalAssignedCustomer
            )}
            {}
            {Labels(
              'Last Batch Update',
              DateFormatter2(collectorData.lastBatchDate)
            )}
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default CollectorDetailHeader;
